import {
  createScheduledDataWorkflow as publicCreateScheduledDataWorkflow,
  rescheduleScheduledDataWorkflow as publicRescheduleScheduledDataWorkflow,
  triggerScheduledDataWorkflowNow as publicTriggerScheduledDataWorkflowNow,
  updateScheduledDataWorkflow as publicUpdateScheduledDataWorkflow,
  deleteScheduledDataWorkflow as publicDeleteScheduledDataWorkflow,
  getScheduledDataWorkflow as publicGetScheduledDataWorkflow,
  listScheduledDataWorkflows as publicListScheduledDataWorkflows,
} from './data-sync-v1-jobs-data-sync-jobs.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onJobsCreated as publicOnJobsCreated } from './data-sync-v1-jobs-data-sync-jobs.public.js';
import { onJobsDeleted as publicOnJobsDeleted } from './data-sync-v1-jobs-data-sync-jobs.public.js';
import { onJobsUpdated as publicOnJobsUpdated } from './data-sync-v1-jobs-data-sync-jobs.public.js';

export const createScheduledDataWorkflow: MaybeContext<
  BuildRESTFunction<typeof publicCreateScheduledDataWorkflow> &
    typeof publicCreateScheduledDataWorkflow
> = /*#__PURE__*/ createRESTModule(publicCreateScheduledDataWorkflow);
export const rescheduleScheduledDataWorkflow: MaybeContext<
  BuildRESTFunction<typeof publicRescheduleScheduledDataWorkflow> &
    typeof publicRescheduleScheduledDataWorkflow
> = /*#__PURE__*/ createRESTModule(publicRescheduleScheduledDataWorkflow);
export const triggerScheduledDataWorkflowNow: MaybeContext<
  BuildRESTFunction<typeof publicTriggerScheduledDataWorkflowNow> &
    typeof publicTriggerScheduledDataWorkflowNow
> = /*#__PURE__*/ createRESTModule(publicTriggerScheduledDataWorkflowNow);
export const updateScheduledDataWorkflow: MaybeContext<
  BuildRESTFunction<typeof publicUpdateScheduledDataWorkflow> &
    typeof publicUpdateScheduledDataWorkflow
> = /*#__PURE__*/ createRESTModule(publicUpdateScheduledDataWorkflow);
export const deleteScheduledDataWorkflow: MaybeContext<
  BuildRESTFunction<typeof publicDeleteScheduledDataWorkflow> &
    typeof publicDeleteScheduledDataWorkflow
> = /*#__PURE__*/ createRESTModule(publicDeleteScheduledDataWorkflow);
export const getScheduledDataWorkflow: MaybeContext<
  BuildRESTFunction<typeof publicGetScheduledDataWorkflow> &
    typeof publicGetScheduledDataWorkflow
> = /*#__PURE__*/ createRESTModule(publicGetScheduledDataWorkflow);
export const listScheduledDataWorkflows: MaybeContext<
  BuildRESTFunction<typeof publicListScheduledDataWorkflows> &
    typeof publicListScheduledDataWorkflows
> = /*#__PURE__*/ createRESTModule(publicListScheduledDataWorkflows);
/** */
export const onJobsCreated: BuildEventDefinition<typeof publicOnJobsCreated> &
  typeof publicOnJobsCreated = createEventModule(publicOnJobsCreated);
/** */
export const onJobsDeleted: BuildEventDefinition<typeof publicOnJobsDeleted> &
  typeof publicOnJobsDeleted = createEventModule(publicOnJobsDeleted);
/** */
export const onJobsUpdated: BuildEventDefinition<typeof publicOnJobsUpdated> &
  typeof publicOnJobsUpdated = createEventModule(publicOnJobsUpdated);

export {
  WixDataEnvironment,
  FileFormat,
  MediaType,
  WixDataDestinationWritePolicy,
  FieldType,
  WixMediaDestinationWritePolicy,
  WritePolicy,
  Fields,
  WebhookIdentityType,
} from './data-sync-v1-jobs-data-sync-jobs.universal.js';
export {
  ScheduledDataWorkflow,
  ScheduledDataWorkflowSpec,
  JobSpec,
  JobSpecSiteOverrideOneOf,
  Source,
  SourceSourceOneOf,
  WixDataSource,
  LocalizationSource,
  FileSource,
  TestSource,
  DataMovementJobLogs,
  ExternalFileSource,
  GoogleSheetsSource,
  WixMediaSource,
  WixDataCollectionDefinitionSource,
  Destination,
  DestinationDestinationOneOf,
  WixDataDestination,
  LocalizationDestination,
  FileDestination,
  Schema,
  Field,
  StoresCatalogProductsDestination,
  WixMediaDestination,
  WixDataCollectionDefinitionDestination,
  StoresCatalogInventoryDestination,
  TestDestination,
  Transformation,
  TransformationTransformationOneOf,
  TestTransformation,
  CreateScheduledDataWorkflowRequest,
  CreateScheduledDataWorkflowResponse,
  RescheduleScheduledDataWorkflowRequest,
  RescheduleScheduledDataWorkflowResponse,
  TriggerScheduledDataWorkflowNowRequest,
  TriggerScheduledDataWorkflowNowResponse,
  UpdateScheduledDataWorkflowRequest,
  UpdateScheduledDataWorkflowResponse,
  DeleteScheduledDataWorkflowRequest,
  DeleteScheduledDataWorkflowResponse,
  GetScheduledDataWorkflowRequest,
  GetScheduledDataWorkflowResponse,
  ListScheduledDataWorkflowsRequest,
  CursorPaging,
  ListScheduledDataWorkflowsResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  JobsCreatedEnvelope,
  JobsDeletedEnvelope,
  JobsUpdatedEnvelope,
  CreateScheduledDataWorkflowOptions,
  RescheduleScheduledDataWorkflowOptions,
  UpdateScheduledDataWorkflowOptions,
  GetScheduledDataWorkflowOptions,
  ListScheduledDataWorkflowsOptions,
} from './data-sync-v1-jobs-data-sync-jobs.universal.js';
export {
  WixDataEnvironmentWithLiterals,
  FileFormatWithLiterals,
  MediaTypeWithLiterals,
  WixDataDestinationWritePolicyWithLiterals,
  FieldTypeWithLiterals,
  WixMediaDestinationWritePolicyWithLiterals,
  WritePolicyWithLiterals,
  FieldsWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './data-sync-v1-jobs-data-sync-jobs.universal.js';
